import {
  GetBookerCommissionsHistogramInput,
  GetDriverPathInput,
  SearchTripV2Input,
} from '@allocab/allocab-passenger-shared-types';

export const queryKeys = {
  tokens: () => ['tokens'],
  user: {
    root: () => ['user'],
    me: () => [...queryKeys.user.root(), 'me'],
    account: () => [...queryKeys.user.root(), 'account'],
    fetchTrips: (input?: Omit<SearchTripV2Input, 'offset' | 'limit'>) => [
      ...queryKeys.user.root(),
      'fetchTrips',
      ...(input ? [input] : []),
    ],
    fetchTripsPage: (input?: SearchTripV2Input) => [
      ...queryKeys.user.root(),
      'fetchTripsPage',
      ...(input ? [input] : []),
    ],
    fetchTrip: (key: string) => [...queryKeys.user.root(), 'fetchTrip', key],
    fetchBookerCommissions: (input?: GetBookerCommissionsHistogramInput) => [
      ...queryKeys.user.root(),
      'fetchBookerCommissions',
      ...(input ? [input] : []),
    ],
    fetchUserTrees: () => [...queryKeys.user.root(), 'fetchUserTrees'],
    fetchCustomRules: () => [...queryKeys.user.root(), 'fetchCustomRules'],
    fetchCanUpdateTrip: (key?: string) => [...queryKeys.user.root(), 'fetchCanUpdateTrip', ...(key ? [key] : [])],
    fetchSuggestions: (searchQueryParam: string | null) => [
      ...queryKeys.user.root(),
      'fetchSuggestions',
      searchQueryParam,
    ],
    fetchItinerary: (
      input: Omit<GetDriverPathInput, 'departureTime'> & {
        departureTime?: GetDriverPathInput['departureTime'];
      },
    ) => [...queryKeys.user.root(), 'fetchItinerary', input],
  },
  fetchAnonymousTrip: (jwtToken?: string) => ['fetchAnonymousTrip', jwtToken],
  fetchAnonymousHelp: (jwtToken?: string) => ['fetchAnonymousTrip', jwtToken],
  fetchAnonymousTripGuideDownload: (jwtToken?: string, tripKey?: string) => [
    'fetchAnonymousTripGuideDownload',
    jwtToken,
    tripKey,
  ],
  fetchTripGuideDownload: (tripKey?: string) => ['fetchTripGuideDownload', tripKey],
};
